import API from './API.ts'

export default {
  //
  // GET
  //
  getBookExports () {
    return API.httpClient.get('accounting/book-exports')
  },
  getAccounts () {
    return API.httpClient.get('accounting/accounts')
  },
  getIncomeAccounts () {
    return API.httpClient.get('accounting/income-accounts')
  },
  downloadReceivablesFile ({ date, fileFormat }) {
    return API.httpClient.get('reports/receivables-report', {
      params: {
        date: date.format('YYYY-MM-DD'),
        file_format: fileFormat
      }
    })
  },
  downloadCustomerCreditsFile ({ date, fileFormat }) {
    return API.httpClient.get('reports/customer-credits-report', {
      params: {
        date: date.format('YYYY-MM-DD'),
        file_format: fileFormat
      }
    })
  },
  getReceivablesData ({ date }) {
    return API.httpClient.get('reports/get-receivables-data', {
      params: {
        date: date.format('YYYY-MM-DD')
      }
    })
  },
  getCustomerCreditsData ({ date }) {
    return API.httpClient.get('reports/get-customer-credits-data', {
      params: {
        date: date.format('YYYY-MM-DD')
      }
    })
  },

  //
  // POST
  //
  createBookExport (month) {
    return API.httpClient.post('accounting/create-book-export', {
      month: month.format('YYYY-MM-DD')
    })
  },
  createIncomeAccount ({ accountNumber, name, taxId }) {
    return API.httpClient.post('accounting/create-income-account', {
      account_number: accountNumber,
      name,
      tax_id: taxId
    })
  }
}
